import React from "react";
import { Icons } from "@texada/ui";

interface PasswordVisibilityProps {
  visible: boolean;
  onToggle?: () => void;
}

export const PasswordVisibility = (props: PasswordVisibilityProps) => {
  const Icon = props.visible ? Icons.Visibility : Icons.VisibilityOff;
  return (
    <Icon
      onClick={e => {
        e.preventDefault();
        props.onToggle();

        (document.querySelector("#password") as HTMLInputElement).focus();
      }}
    />
  );
};
